import { pipe, Either, Task } from "fp";

import { type, creator, reducer, effects } from "~/Action";
import * as Data from "~/Data";
import * as TimeTracking from "~/TimeTracking";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("Time tracking entries requested" as const),
    reducer(({ state }) => {
      state.timeTracking.entries.store = Data.Store.requested(
        state.timeTracking.entries.store
      );
    }),
    effects(
      ({ dispatch, state: { context, logs } }) =>
        logs.active &&
        pipe(
          context,
          TimeTracking.Entry.Request.Get.request(logs.active),
          Task.map((entries) => dispatch(Received.create(entries)))
        )()
    )
  );
}

export namespace Received {
  export const { TYPE, create, reduce } = pipe(
    type("Time tracking entries received" as const),
    creator(
      (
        entries: Either.ErrorOr<Data.Cache.Cache<TimeTracking.Entry.Entry>>
      ) => ({ entries })
    ),
    reducer(
      ({ state, action: { entries } }) =>
        (state.timeTracking.entries.store = pipe(
          state.timeTracking.entries.store,
          Data.Store.received(entries)
        ) as typeof state.timeTracking.entries.store)
    )
  );
}
